import React, { useState } from "react";
import {
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from "@mui/material";
import { Spin } from "antd"; // For loader/spinner
import { CopyAll as CopyIcon } from "@mui/icons-material"; // Import the Copy icon
import { momentDate, SAAS_SITE_URL } from "../../utils";

const RecentUpdatedTables = (props) => {
  const [copySuccess, setCopySuccess] = useState(false);

  // Define recent update table data
  const recentUpdatedTable = {
    feeCollection: props.recentUpdateTables?.feeTable.latest_bill_date,
    homework: props.recentUpdateTables?.homeworkTable.latest_updated_date,
    certificate: props.recentUpdateTables?.certificateTable.latest_updated_date,
    events: props.recentUpdateTables?.eventTable.latest_updated_date,
    admission: props.recentUpdateTables?.applicationTable.latest_updated_date,
    students: props.recentUpdateTables?.studentTable.latest_updated_date,
  };

  const tableData = [
    {
      sno: 1,
      module: "Fee Collection",
      date: recentUpdatedTable.feeCollection,
    },
    { sno: 2, module: "Homework", date: recentUpdatedTable.homework },
    { sno: 3, module: "Certificate", date: recentUpdatedTable.certificate },
    { sno: 4, module: "Events", date: recentUpdatedTable.events },
    { sno: 5, module: "Admission", date: recentUpdatedTable.admission },
    { sno: 6, module: "School", date: recentUpdatedTable.students },
  ];

  return (
    <div>
      <div id="contentToCopy">
        <Grid container spacing={1}>
          <Grid item xs={12} sx={{ mt: 3 }}>
            {" "}
            {/* Adjust mt value as needed */}
            <Box
              sx={{
                display: "flex", // Flexbox for alignment
                justifyContent: "center", // Center horizontally
                alignItems: "center", // Center vertically (if you have multiple lines)
              }}
            >
              <Box
                sx={{
                  backgroundColor: "#1976d2", // Background color
                  padding: "10px 15px", // Adjust padding for text space
                  borderRadius: "8px", // Rounded corners
                }}
              >
                <Typography
                  variant="h5"
                  align="center"
                  gutterBottom
                  sx={{ color: "white" }}
                >
                  Recent Activities of the School
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <TableContainer
              component={Paper}
              sx={{ border: "1px solid #1976d2", borderRadius: "8px" }}
            >
              <Table sx={{ borderCollapse: "collapse" }}>
                <TableHead sx={{ backgroundColor: "#1976d2" }}>
                  <TableRow>
                    <TableCell
                      sx={{ color: "white", border: "1px solid #1976d2" }}
                    >
                      <strong>S.No.</strong>
                    </TableCell>
                    <TableCell
                      sx={{ color: "white", border: "1px solid #1976d2" }}
                    >
                      <strong>Module</strong>
                    </TableCell>
                    <TableCell
                      sx={{ color: "white", border: "1px solid #1976d2" }}
                    >
                      <strong>Date</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData.map((row) => (
                    <TableRow key={row.sno}>
                      <TableCell sx={{ border: "1px solid #1976d2" }}>
                        {row.sno}
                      </TableCell>
                      <TableCell sx={{ border: "1px solid #1976d2" }}>
                        {row.module}
                      </TableCell>
                      <TableCell sx={{ border: "1px solid #1976d2" }}>
                        {momentDate(row.date, "DD-MM-YYYY") || "No Data"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default RecentUpdatedTables;
